/// <reference types="@wix/yoshi-flow-library/types" />

declare module '*.riv' {
  const src: string;
  export default src;
}
